import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { leaderboardApi } from '../../config';

@Injectable({
  providedIn: 'root'
})
export class LeaderboardService {

  constructor(private apiService: ApiService) { }

  getGeneralLeaderboard(companyId: string, userType: any) {
    return this.apiService.get(leaderboardApi.getGeneralLeaderboard + companyId + '?console=' + userType);
  }

  getMngrChallngLdbrd(userId: string) {
    return this.apiService.get(leaderboardApi.getMngrChallngLdbrd + userId);
  }

  getManagerChallengesByType(userId: string, challengeType: string, compId: any) {
    let pamCompId: any;
    if (compId) {
      pamCompId = compId;
      return this.apiService.get(leaderboardApi.getMngrChallngLdbrd + userId + '/' + challengeType + '?companyId=' + pamCompId);
    }
    return this.apiService.get(leaderboardApi.getMngrChallngLdbrd + userId + '/' + challengeType);
  }

  getSellerChallengesByType(userId: string, challengeType: string) {
    return this.apiService.get(leaderboardApi.getSellerChallngLdbrd + userId + '/' + challengeType);
  }

  getSellerChallngLdbrd(userId: string) {
    return this.apiService.get(leaderboardApi.getSellerChallngLdbrd + userId);
  }

  getMoreLeaderboards(reqObj: any) {
    return this.apiService.get(leaderboardApi.getGeneralLeaderboard + reqObj.companyId + '/' + reqObj.type + '?page=' + reqObj.page + '&size=' + reqObj.size);
  }

  getMoreManagerChallng(reqObj: any) {
    return this.apiService.get(leaderboardApi.getMngrChallngLdbrd + reqObj.userId + '/' + reqObj.type + '/' + reqObj.itemId + '?page=' + reqObj.page + '&size=' + reqObj.size);
  }

  getMoreSellerChallng(reqObj: any) {
    return this.apiService.get(leaderboardApi.getSellerChallngLdbrd + reqObj.userId + '/' + reqObj.type + '/' + reqObj.itemId + '?page=' + reqObj.page + '&size=' + reqObj.size);
  }

  getMoreChallenges(pathParams: any, queryParams: any) {
    if (pathParams.companyId) {
      return this.apiService.get(leaderboardApi.getMoreChallenges + pathParams.type + '/' + pathParams.challengeId + '?companyId=' + pathParams.companyId, queryParams);
    }
    return this.apiService.get(leaderboardApi.getMoreChallenges + pathParams.type + '/' + pathParams.challengeId, queryParams);
  }

  getActivationChallenges(companyId: any, queryParams: any) {
    return this.apiService.get(leaderboardApi.getActivationChallenges + companyId, queryParams);
  }

  getTopCiscoBookings(queryParams: any) {
    return this.apiService.get(leaderboardApi.getTopCiscoBookings, queryParams);
  }

  getFiscalDropDownList() {
    return this.apiService.get(leaderboardApi.getFiscalDropDownList);
  }

  getFiscalPamDropdownList() {
    return this.apiService.get(leaderboardApi.getFiscalPamDropdownList);
  }

  getPartnersLeaderboardData(queryParams: any) {
    return this.apiService.get(leaderboardApi.getPartnersLeaderboardData + queryParams);
  }

  getdistiChallengeRequest(body: any) {
    return this.apiService.get(leaderboardApi.distributionLeaderboard + body);
  }

  getquaterListForDistributorChgFlag(body: any) {
    return this.apiService.get(leaderboardApi.leaderboardQuaterList + body);
  }

  getActivityLeaderboardChallengeTypes(req: any) {
    return this.apiService.get(leaderboardApi.activityLeaderboardChagTypes + req);
  }

  getActivityLeaderboardSubCategory(req: any) {
    return this.apiService.get(leaderboardApi.activityLeaderboardSubCategory + req);
  }

  getSalesLeaderBoardList(companyId: string, userType: any) {
    return this.apiService.get(leaderboardApi.getSalesLeaderboardList + companyId + '?console=' + userType);
  }

  getSalesLeaderboardData(reqObj: any) {
    return this.apiService.get(leaderboardApi.getSalesLeaderboardData + reqObj);
  }

  getLeaderboardChallengeList(req: any) {
    return this.apiService.get(leaderboardApi.LeaderboardChallenges + req);
  }

  getLeaderboardChallengeData(req: any) {
    return this.apiService.get(leaderboardApi.leaderboardChallengeData + req);
  }

  getLeaderboardChgSubcategoryData(req: any) {
    return this.apiService.get(leaderboardApi.leaderboardChgsSubcategoryData + req);
  }

  getLeaderboardRankDetails(req: any) {
    return this.apiService.get(leaderboardApi.leaderboardRankDetails + req);
  }

  getActivityLeaderboardRankDetails(req: any) {
    return this.apiService.get(leaderboardApi.activityLeaderboardRankDetails + req);
  }

  uploadLeaderboardChgDocuments(filedata: any, params: any) {
    return this.apiService.postForFile(
      leaderboardApi.uploadLeaderboardDocuments + params, filedata
    );
  }

}
